var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevLeft = function SvgChevLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#chev-left_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.216 7.333h8.115v1.333H5.216l3.576 3.576-.943.943L2.664 8 7.85 2.814l.943.943z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "chev-left_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgChevLeft;